<div class="client-wrapper">
  <section class="top-bar">
    <app-navbar></app-navbar>
  </section>
  <section class="bl-main-wrapper">
    <router-outlet></router-outlet>
  </section>
</div>

<app-side-quiz></app-side-quiz>